import { usePreInstallAcr } from "@/api/useIntegrations"
import { Breadcrumb, Form, Link } from "@/atoms"
import { INTEGRATION_VENDORS } from "@/const/vendors-constants"
import { useTranslation } from "@/hooks/useTranslation"
import { Heading } from "@/molecules/Heading"
import { HeaderPage } from "@/organisms/HeaderPage"
import { AcrFederation } from "@/pages/IntegrationsPage/components/molecules/AcrFederation"
import { FormAcr } from "@/pages/IntegrationsPage/components/molecules/FormAcr"
import { useAcrAPI } from "@/pages/IntegrationsPage/hooks/useAcrAPI"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"
import { PageWithBreadcrumbTemplate } from "@/templates/PageWithBreadcrumbTemplate"
import { ConnectIntegrationFooter } from "../ConnectIntegrationPage/ConnectIntegrationFooter"

import styles from "./AcrIntegrationPage.module.scss"

export const AcrIntegrationPage = () => {
  const { t } = useTranslation()
  const vendor = INTEGRATION_VENDORS.acr
  const [_, { onRemove: _onRemove, ...formProps }] = useIntegration({ vendor })
  const acrApi = useAcrAPI(formProps)
  const { response, isError, isFetching, refetch } = usePreInstallAcr()
  const title = t("integrations.acr.title")
  const loginServer: string | undefined = Form.useWatch(
    "registry",
    formProps.form
  )

  return (
    <PageWithBreadcrumbTemplate
      full
      header={
        <HeaderPage
          title={
            <Breadcrumb
              items={[
                {
                  title: (
                    <Link to="/integrations">
                      {t("navigation.integrations")}
                    </Link>
                  )
                },
                {
                  title: (
                    <Link to={formProps.getBackToIntegrationUrl()}>
                      Azure Container Registry
                    </Link>
                  )
                },
                { title }
              ]}
            />
          }
        />
      }
      footer={
        <ConnectIntegrationFooter
          disabled={!formProps.isDirty}
          isLoading={acrApi.isPending}
          okText={t("integrations.acr.form.buttons.connect")}
          okProps={{ form: acrApi.formId, htmlType: "submit" }}
          onCancel={() => formProps.backToIntegration()}
        />
      }
    >
      <div className={styles.title}>
        <Heading level={4} title={title} />
      </div>
      <AcrFederation
        federation={response?.data}
        loginServer={loginServer}
        failed={isError && !isFetching}
        onRetry={() => refetch()}
      />
      <Heading level={6} title={t("integrations.acr.form.title")} />
      <FormAcr
        formId={acrApi.formId}
        onFinish={acrApi.onFinish}
        {...formProps}
      />
    </PageWithBreadcrumbTemplate>
  )
}
